// extracted by mini-css-extract-plugin
module.exports = {"attrLabel":"index-module--attr-label--1UiLa","collapseIcon":"index-module--collapse-icon--1JRAa"};